import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Link, useNavigate } from "react-router-dom"
import { useReactToPrint } from "react-to-print"

import FooterSticky from "./footerSticky"
import close_icon from "../../../assets/common/close_icon.svg"
import error from "../../../assets/common/error.svg"
import print from "../../../assets/common/print.svg"
import leftArrow from "../../../assets/common/prvsArrow.svg"
import tick from "../../../assets/common/tick.svg"
import tick_icon from "../../../assets/common/tick_icon.svg"
import Loader from "../../../components/Common/Loader/loader"
import ReactTable from "../../../components/Common/ReactTable"
import ToastNotification, { notify } from "../../../components/Toast"
import { DateFormate } from "../../../components/Utility/DateFormate"
import { useSendOrder } from "../../../services/mutations"
import { useFetchRecord,useGetAllOrderCartView, useGetShipToDetails } from "../../../services/queries"
import { customNotification } from "../../../utils/utils"

const loginDetails = sessionStorage.getItem("userDetails")
const loggedInUserDetails = loginDetails
    ? JSON.parse(loginDetails)?.user_details
    : {}

const ReviewOrder = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [shipToAddress, setShipToAddress] = useState([])
    const [weight, setWeight] = useState(0)
    const [total, setTotal] = useState(0)
    const [selectedShipToAddress, setSelectedShipToAddress] = useState([])
    const [selectedShipToRows, setSelectedShipToRows] = useState(0)
    const [loader, setLoader] = useState(false)
    const [result, setResult] = useState({})
    const [successSendOrder, setSuccessSendOrder] = useState(false)
    const [pricechkItem, setPricechkItem] = useState(true)
    const [purchaseOrder, setPurchaseOrder]= useState("")
    const [comments, setComments]= useState("")
    const [serviceCenterAndOrg, setServiceCenterAndOrg] = useState({})
    const [functionNumber, setfunctionNumber] = useState("")
    const [scNameList] = useState(localStorage.getItem("serviceCenterID"))
    const [notifyEmail, setNotifyEmail] = useState("")
    const printRef = useRef(null)
    let salrOrgFilter = ""
    const functionDetailsLoggedInUser = loginDetails
        ? JSON.parse(loginDetails)?.user_details?.service_center_details[0]?.function
        : {}
    const { isLoading: isSCLoading, data: fetchSCList } = useFetchRecord("service-center")	
    const { data: listOrderCardView = [], status: cartViewStatus } = useGetAllOrderCartView(functionDetailsLoggedInUser, scNameList)

    const { data: serviceCenterDetails = [], status: serviceCenterStatus } = useGetShipToDetails(scNameList)
    const { mutateAsync: sendOrder } = useSendOrder()

    let extractMoney = function(string) {
        let amount = string.match(/[0-9]+([,.][0-9]+)?/)
        if (amount) {
            return amount = +amount[0].replace(",", ".")
        }
        return null
    }

    useEffect(() => {
        if (!successSendOrder && listOrderCardView?.data) {
            setData((prevData) => {
                if (JSON.stringify(prevData) !== JSON.stringify(listOrderCardView.data)) {
                    return listOrderCardView?.data || []
                }
                return prevData
            })
            let priceList = listOrderCardView?.data
            let priceArr = []
            let priceChk = priceList.filter(function(item) { 
                let convertPrice = extractMoney(item.price)
                priceArr.push(convertPrice)
                return priceArr
            })
            if(priceArr.includes(0)){
                setPricechkItem(false)
            }
            setWeight(listOrderCardView?.total_weight)
            setTotal(listOrderCardView?.total_price)
            setServiceCenterAndOrg(listOrderCardView?.ServiceCenterAndOrgData)

            if(fetchSCList?.data.length > 0){
                let currentServiceCenter = fetchSCList?.data.filter((item) => {   return item.number == serviceCenterAndOrg?.serviceCenterData?.number  })
                let currentSaleOrg = currentServiceCenter[0]?.sales_orgs_details.filter((saleOrgItem) => { return saleOrgItem.function.includes("order") })
                setfunctionNumber(currentSaleOrg)
            }
        }
        if(serviceCenterDetails?.shipToAddress){
            setShipToAddress((prevData) => {
                if (JSON.stringify(prevData) !== JSON.stringify(listOrderCardView.data)) {
                    return serviceCenterDetails?.shipToAddress || []
                }
                return prevData
            })
            setSelectedShipToAddress([ { ...serviceCenterDetails?.shipToAddress[0] }] || [])
            setNotifyEmail(serviceCenterDetails?.shipToAddress[0]?.pg_notify_email)
        }
       

    }, [listOrderCardView, serviceCenterDetails, successSendOrder, scNameList,fetchSCList,functionNumber])

    useEffect(() => {
        if (cartViewStatus === "success" && serviceCenterStatus === "success") {
            setLoader(false)
        } else {
            setLoader(true)
        }
    }, [cartViewStatus, serviceCenterStatus])

    useEffect(()=>{   
        const local = localStorage.getItem("basketOverviewData")
        if(!successSendOrder && local?.length > 0)
        {
            const storageData = JSON.parse(local)
            setPurchaseOrder(storageData?.purchaseOrder)
            setComments(storageData?.comments)
        }   
    }, [successSendOrder])


    const sortData = (a, b, id) => {
        const valueA = a.values[id] || " "
        const valueB = b.values[id] || " "

        const numA = parseFloat(valueA)
        const numB =  parseFloat(valueB)
        if(!isNaN(numA) && !isNaN(numB)) {
            return numA > numB ? 1: -1
        }

        const alphaNumA = valueA.toString()
        const alphaNumB = valueB.toString()
        return alphaNumA.localeCompare(alphaNumB, undefined, { numeric:true })
    }

    const handleSendOrder = async () => {
        if(!pricechkItem){
            setLoader(false)
            setSuccessSendOrder(false)
            notify("ERROR", t("errorMessage.allPartPrice"))
            return false
        }
        try {
            setLoader(true)
            let priceSplit = total?.split(" ")
            const payload= {
                purchase_order_number: purchaseOrder || "",
                customer_number: serviceCenterAndOrg?.serviceCenterData?.number || "",
                ship_type_id: selectedShipToAddress[0]?.ship_to_type || "",
                ship_to_customer_number: (`${selectedShipToAddress[0]?.ship_to_number}` != "undefined") ? `${selectedShipToAddress[0]?.ship_to_number.toString()}` : "",
                total_order_price: priceSplit?.length > 1 ? parseFloat(priceSplit[1]) : "",
                total_order_weight: parseInt(weight),
                order_comment: comments|| "",
                order_email: selectedShipToAddress[0]?.order_email || "",
                sender_email: selectedShipToAddress[0]?.sender_email || "",
                notify_email: notifyEmail || "",
                service_center_function: loggedInUserDetails?.service_center_details[0]?.function,
                sales_org:`${serviceCenterAndOrg?.salesOrgData?.org_code.toUpperCase()}`,
                function_number:functionNumber !==undefined ? functionNumber[0]?.function_number : "",
                loggedInId:loggedInUserDetails?.id
            }
            localStorage.removeItem("basketOverviewData")
            let result = await sendOrder(payload)
            if (result) {
                setLoader(false)
                setSuccessSendOrder(true)
                localStorage.setItem("successSendOrder",true)
                localStorage.removeItem("basketOverviewData")
                localStorage.removeItem("serviceCenterID")
                navigate("/order/confirmation")
                setResult({
                    orderId: result?.id,
                    processDate: DateFormate(result?.process_date),
                    responseMessage: result?.message,
                    isError: result?.isError
                })
            }
        } catch (error) {
            setLoader(false)
            setSuccessSendOrder(false)
            notify("ERROR", customNotification(error?.message, t))
        }
    }

    const columns = [
        {
            Header: t("orderManagement.position"),
            accessor: "position",
            Cell: ({ row }) => {
                return <div>{ row?.index + 1 }</div>
            }

        },
        {
            Header: t("orderManagement.partNo"),
            accessor: "part_number",
            sortType: (rowA, rowB, columnId) =>sortData(rowA, rowB, columnId)
        },
        {
            Header: t("orderManagement.ean"),
            accessor: "ean",
            sortType: (rowA, rowB, columnId) =>sortData(rowA, rowB, columnId)
        },
        {
            Header: t("orderManagement.qty"),
            accessor: "qty",
            canSort: true 
        },
        {
            Header: t("orderManagement.price"),
            accessor: "price",
            canSort: true 
        },
        {
            Header: t("orderManagement.stock"),
            accessor: "stock",
            Cell: ({ value }) =>
                value === 1
                    ? (<img src={ tick_icon } alt="tick" />) : (<img src={ close_icon } alt="close" />)
        },
        {
            Header: t("orderManagement.partDescription"),
            accessor: "part_description",
            sortType: (rowA, rowB, columnId) =>sortData(rowA, rowB, columnId)
        },
        {
            Header: t("orderManagement.reference"),
            accessor: "reference",
            sortType: (rowA, rowB, columnId) =>sortData(rowA, rowB, columnId)
        }
    ]

    const shipToColumns = [
        {
            Header: t("reviewOrder.shipToNo"),
            accessor: "ship_to_number",
            sortType: (rowA, rowB, columnId) =>sortData(rowA, rowB, columnId)
        },
        {
            Header: t("reviewOrder.type"),
            accessor: "ship_to_type",
            sortType: (rowA, rowB, columnId) =>sortData(rowA, rowB, columnId)
        },
        {
            Header: t("reviewOrder.destination"),
            accessor: "port",
            canSort: true 
        },
        {
            Header: t("reviewOrder.email"),
            accessor: "contact_email",
            canSort: true 
        },
        {
            Header: t("reviewOrder.phone"),
            accessor: "phone_number",
            sortType: (rowA, rowB, columnId) =>sortData(rowA, rowB, columnId)
        }
    ]
    const newShipToColumns = [
        {
            id: "selection",
            Cell: ({ row }) => (
                <input
                    id="shipTo"
                    type="radio"
                    name="shipTo"
                    onChange={ (e) => onChangeHand(e, row) }
                    checked = { selectedShipToRows=== row?.index ? true : false }
                    className="w-[18px] h-[18px] border border-primary-50 focus:ring-primary-50 text-primary-50"
                />
            )
        },
        ...shipToColumns
    ]

    const handlePrint = useReactToPrint({
        contentRef: printRef
    })
    
    const onChangeHand=(e, row)=>{
        setSelectedShipToRows(row?.index)
        setSelectedShipToAddress([{ ...row?.original }])
    }

    const renderShipToReview =() =>{
        return <> { t("reviewOrder.selectMessage") } <span className="text-red">*</span> </>
    }

    const renderConfirmSuccessMessage =()=>{
        return(
            <>
                <div className="flex justify-between items-center pb-2 px-4">
                    <div className= "flex">
                        <div className="-mt-1 pr-1">
                            { (result?.isError) ? <img src={ error } alt= "error" /> : <img src={ tick } alt= "success" /> }
                        </div>
                        <div className={ `text-md font-black ${( result?.isError) ? "text-red":"text-green"} ` }>
                            { customNotification(result?.responseMessage, t) }
                        </div>
                    </div>
                    <div id="printConfirmation" className="-mb-2">
                        <div className="inline-flex">
                            <img src={ print } alt="print" />
                            <Link  
                                onClick={ handlePrint }
                                className="underline decoration-solid text-primary-100 pl-1">
                                { t("confirmOrder.print") }
                            </Link>
                        </div>
                    </div>
                </div>
            </>
        )
    }
    const renderReviewCheckMessage =()=>{
        return(
            <div className="flex justify-between items-center pb-2 px-4">
                <h3 className="text-md font-black text-primary-50">
                    { t("reviewOrder.checkMessage") }
                </h3>
            </div>
        )
    }

    return (
        <>
            { <Loader loading = { loader } /> }
            <div className="headings px-8 pb-3">
                <h3 className="flex items-center text-xl text-primary-50 font-black ml-2 ">
                    <Link to="/order" 
                        className=" flex items-center"
                    >
                        <img src={ leftArrow } alt="Back Arrow" className="mr-3" />{ " " }
                        { (!successSendOrder)? t("pageTitle.reviewOrder"): t("pageTitle.confirmOrder") }
                    </Link>
                </h3>
            </div>
            <div ref={ printRef } className="px-8 pt-4 gap-6 bg-primary-200 w-full pb-0">
                <div className="m-auto">
                    <div className="bg-white pt-5 pb-2 rounded-t-lg border border-lightGray">
                        { (!successSendOrder)? renderReviewCheckMessage() : renderConfirmSuccessMessage() }
                        <div className="bg-lighestgray px-4">
                            <div className="flex text-xs text-secondary-200">
                                <ul className="text-xs text-secondary-200 w-full">
                                    <li className="border-lightGray border-b py-2">
                                        <span className="text-secondary-50 pr-6"> 
                                            { t("reviewOrder.customerNumber") }:
                                            { ` ${serviceCenterAndOrg?.serviceCenterData?.number || ""}`  }  
                                        </span>
                                        { (successSendOrder) && 
                                            <>
                                                <span className="text-secondary-50  pr-6"> 
                                                    { t("confirmOrder.orderId") }:
                                                    { ` ${result?.orderId || ""}`  }
                                                </span>
                                                <span className="text-secondary-50  pr-6"> 
                                                    { t("confirmOrder.processed") }:
                                                    { ` ${result?.processDate || ""}`  }
                                                </span>
                                            </>
                                        }
                                    </li>

                                    <li className="pt-2 text-secondary-50">
                                        { `${serviceCenterDetails?.data?.building?.concat(",") || ""} 
                                            ${serviceCenterDetails?.data?.street?.concat(",") || ""} 
                                            ${serviceCenterDetails?.data?.city?.concat(",") || ""} ` }  
                                    </li>
                                    <li className="pt-2 text-secondary-50">
                                        { `${serviceCenterDetails?.data?.state?.concat(",") || ""} 
                                            ${serviceCenterDetails?.data?.country_name?.concat(",") || ""} 
                                            ${serviceCenterDetails?.data?.zip_code?.concat(".") || ""} `  }  
                                    </li>
                                    <li className="border-lightGray border-b py-2">{ t("reviewOrder.salesOrg") }: 
                                        <span className="text-secondary-50">
                                            { serviceCenterAndOrg?.salesOrgData?.org_code ? ` ${serviceCenterAndOrg?.salesOrgData?.org_code.toUpperCase()}` : "" }
                                        </span>
                                    </li>
                                    <li className="border-lightGray border-b py-2">{ t("reviewOrder.functionNumber") }: 
                                        <span className="text-secondary-50">
                                            { functionNumber !==undefined ? functionNumber[0]?.function_number : "" }
                                        </span>
                                    </li>
                                    <li className="pt-2">{ t("reviewOrder.purchaseOrderNo") }:  
                                        <span className="text-secondary-50">
                                            { ` ${purchaseOrder|| ""}` }
                                        </span>
                                    </li>
                                    <li className="py-2">{ t("reviewOrder.comments") }: 
                                        <span className="text-secondary-50">{ ` ${comments|| ""}` }</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        { shipToAddress?.length > 0 && 
                            <div className="py-4">
                                <div className="flex justify-between items-center pb-2 px-4">
                                    <h3 className="text-md font-black text-primary-50">
                                        { (!successSendOrder)?  renderShipToReview()
                                            :  t("confirmOrder.shipToDetails") }
                                    </h3>
                                </div>
                                <ReactTable
                                    columns={ (!successSendOrder)? newShipToColumns: shipToColumns }
                                    data={ (!successSendOrder)? shipToAddress: selectedShipToAddress }
                                    disableSearch={ true }
                                    status={ status }
                                />
                            </div>
                        }
                        <>
                            <div className="flex justify-between items-center border-b border-b-gray  pb-2 px-4">
                                <h3 className="text-md font-black text-primary-50">
                                    { t("reviewOrder.partList") }
                                </h3>
                                
                            </div>
                            <ReactTable
                                columns={ columns }
                                data={ data }
                                disableSearch={ true }
                                status={ status }
                            />
                        </>
                    </div>
                </div>
            </div>
            { (!successSendOrder) && <FooterSticky
                isBlocked= { false }
                onhandleOrder = { handleSendOrder }
                weight={ weight }
                total={ total }
                title={ t("reviewOrder.sendOrder") }
                checkOrderInFunction = { true }
            /> }
            <ToastNotification />
            
        </>
    )
}

export default ReviewOrder
